<template>
  <div>
  <v-row class="mt-0 px-5" style="margin-top: -2%;">
      <v-col cols="12" sm="6" md="4" lg="4" class="pt-0 pb-0 mt-lg-6">
        <span class="head-search-text">ประเภทสิทธิ์การใช้งาน</span>
        <v-select
          v-model="keywordRoleType"
          :items="itemRoleType"
          multiple
          outlined
          placeholder="ค้นหา ประเภทสิทธิ์การใช้งาน"
          item-text="name"
          item-value="_id"
          class="mt-2"
          dense
          @change="searchFilterData()"
        >
        <template v-slot:prepend-item v-if="itemRoleType.length > 1">
          <v-list-item
            ripple
            @click="toggleRolType"
          >
            <v-list-item-action>
              <v-icon :color="keywordRoleType.length > 0 ? 'indigo darken-4' : ''">
                {{ iconRoleType }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                เลือกทั้งหมด
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-0"></v-divider>
        </template>
        <template #selection="{ item, index }">
          <v-chip  v-if="index === 0" color="#EFF4FD !important" label small>
            <span v-if="keywordRoleType.length !== itemRoleType.length" class="filter-chip_department" style="color: #3776E9">{{item.name}}</span>
            <span v-else-if="keywordRoleType.length === itemRoleType.length" class="filter-chip_department" style="color: #3776E9">ทั้งหมด</span>
          </v-chip>
          <v-chip  v-if="index === 1 && keywordRoleType.length !== itemRoleType.length" color="#EFF4FD !important" label small>
            <span class="filter-chip_department" style="color: #3776E9">(+{{ keywordRoleType.length - 1 }} เพิ่มเติม)</span>
          </v-chip>
        </template>
      </v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" class="pt-0 pb-0 mt-lg-6">
        <span class="head-search-text">ชื่อสิทธิ์การใช้งาน</span>
        <v-select
          v-model="keywordRoleName"
          :items="itemRoleName"
          multiple
          outlined
          placeholder="ค้นหา ชื่อสิทธิ์การใช้งาน"
          item-text="name"
          item-value="_id"
          class="mt-2"
          dense
          @change="searchFilterData()"
        >
        <template v-slot:prepend-item v-if="itemRoleName.length > 1">
            <v-list-item
              ripple
              @click="toggleRoleName"
            >
              <v-list-item-action>
                <v-icon :color="keywordRoleName.length > 0 ? 'indigo darken-4' : ''">
                  {{ iconRoleName }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  เลือกทั้งหมด
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-0"></v-divider>
          </template>
          <template #selection="{ item, index }">
            <v-chip  v-if="index === 0" color="#EFF4FD !important" label small>
              <span v-if="keywordRoleName.length !== itemRoleName.length" class="filter-chip_department" style="color: #3776E9">{{item.name}}</span>
              <span v-else-if="keywordRoleName.length === itemRoleName.length" class="filter-chip_department" style="color: #3776E9">ทั้งหมด</span>
            </v-chip>
            <v-chip  v-if="index === 1 && keywordRoleName.length !== itemRoleName.length" color="#EFF4FD !important" label small>
              <span class="filter-chip_department" style="color: #3776E9">(+{{ keywordRoleName.length - 1 }} เพิ่มเติม)</span>
            </v-chip>
          </template>
        </v-select>
      </v-col>
      <!-- <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 d-flex align-end" style="padding-bottom: 1.5%;">
        <v-row class="pl-3 pr-3" style="margin-bottom: 0px;">
          <v-btn outlined color="primary" class="mr-5" style="min-height: 30px;" @click="searchFilterData()">ค้นหา</v-btn>
          <v-btn outlined color="primary" class="" style="min-height: 30px;" @click="resetFilterData()">ล้างข้อมูล</v-btn>
        </v-row>
      </v-col> -->
      <v-col cols="12" sm="12" md="4" lg="4" class="pt-0 pb-0 d-flex align-center justify-end mt-4">
        <v-btn
          outlined
          class="button-color ra-button-permission"
          dark
          @click="gotocreate()"
        >
        <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
        <span class="ra-text-in-button-permission">
          เพิ่มสิทธิ์
        </span>
      </v-btn>
      </v-col>
      <!-- <v-col cols="12" sm="12" md="6" lg="4" class="pt-0 pb-0 d-flex align-end">
        <v-row class="pl-3 pr-3" style="margin-bottom: 14px;">
          <v-btn class="mr-5" style="min-height: 38px;" color="success" dark @click="searchFilterData()">ค้นหา</v-btn>
          <v-btn class="" style="min-height: 38px;" outlined color="success" dark @click="resetFilterData()">ล้างข้อมูล</v-btn>
        </v-row>
      </v-col> -->
    </v-row>
</div>
</template>

<script>
import { EventBus } from '@/EventBus'

export default {
  name: 'filter-workgroup',
  data () {
    return {
      keywordRoleName: [],
      keywordRoleType: [],
      chkRoleName: '',
      memoryRoleName: [],
      chkRoleType: '',
      memoryRoleType: [],
      filterData: {
        companyShortName: [],
        managementName: '',
        managementHeader: '',
        userName: '',
        userPosition: ''
      },
      itemSmall: ['INET', 'OGS'],
      itemLineWorkName: [],
      itemRoleType: [],
      itemRoleName: [],
      itemGroupCompanyName: [],
      itemsSmallDep: [{
        id: 0,
        value: 0,
        label: 'INET'
      }, {
        id: 1,
        value: 1,
        label: 'MANDALA'
      }]
    }
  },
  computed: {
    selectAllRoleType () {
      return this.keywordRoleType.length === this.itemRoleType.length
    },
    selectSomeRoleType () {
      return this.keywordRoleType.length > 0 && !this.selectAllRoleType
    },
    iconRoleType () {
      if (this.selectAllRoleType) return 'mdi-close-box'
      if (this.selectSomeRoleType) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectAllRoleName () {
      return this.keywordRoleName.length === this.itemRoleName.length
    },
    selectSomeRoleName () {
      return this.keywordRoleName.length > 0 && !this.selectAllRoleName
    },
    iconRoleName () {
      if (this.selectAllRoleName) {
        return 'mdi-close-box'
      }
      if (this.selectSomeRoleName) {
        return 'mdi-minus-box'
      }
      return 'mdi-checkbox-blank-outline'
    }
  },
  watch: {
    keywordRoleName: function (val) {
      if (val.length) {
        this.filterData.companyShortName = val
      }
      // EventBus.$emit('detailCompany', nodeId)
    },
    keywordLineWorkName: function (val) {
      if (val.length) {
        this.filterData.managementName = val
      }
      // EventBus.$emit('detailCompany', nodeId)
    }
  },
  mounted () {
    EventBus.$on('getPosition', this.getSelectData)
    EventBus.$on('selectRole', this.getSelectValue)
  },
  methods: {
    toggleRolType () {
      this.$nextTick(() => {
        if (this.selectAllRoleType) {
          this.chkRoleType = false
          this.keywordRoleType = []
        } else {
          this.chkRoleType = true
          this.keywordRoleType = this.itemRoleType.slice()
          for (let index = 0; index < this.keywordRoleType.length; index++) {
            this.memoryRoleType.push(this.keywordRoleType[index]._id)
          }
          this.searchFilterData()
        }
      })
    },
    toggleRoleName () {
      this.$nextTick(() => {
        if (this.selectAllRoleName) {
          this.chkRoleName = false
          this.keywordRoleName = []
        } else {
          this.chkRoleName = true
          this.keywordRoleName = this.itemRoleName.slice()
          for (let index = 0; index < this.keywordRoleName.length; index++) {
            this.memoryRoleType.push(this.keywordRoleName[index]._id)
          }
          this.searchFilterData()
        }
      })
    },
    getSelectValue (data) {
      this.itemSmall = data.companyShortName
      this.itemRoleType = data.permissionsType
      this.itemRoleName = data.permissionName
      this.itemGroupCompanyName = data.groupCompanyName
    },
    getSelectData (data) {
      this.itemSmall = data.companyShortName
      this.itemRoleType = data.companyName
      this.itemGroupCompanyName = data.groupCompanyName
    },
    resetFilterData () {
      this.keywordRoleName = ''
      this.keywordRoleType = []
      this.filterData = {
        roleName: [],
        roleType: [],
        groupCompany: [],
        limit: 50,
        page: 1
      }
      EventBus.$emit('filterPosition', this.filterData)
    },
    searchFilterData () {
      this.filterData = {
        roleName: this.chkRoleName === true ? this.memoryRoleName : this.keywordRoleName,
        roleType: this.chkRoleType === true ? this.memoryRoleType : this.keywordRoleType,
        limit: 50,
        page: 1
      }
      EventBus.$emit('filterPosition', this.filterData)
    },
    gotocreate () {
      this.$router.push('managerole/create')
    }
  }
}
</script>

<style scoped>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
.ra-button-permission {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* padding: 9px 24px; */

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button-permission {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
</style>
